import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_khkkpxpgu3: FaireBrandEntity = {
  token: "b_khkkpxpgu3",
  type: "brand",
  name: "6pm Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/4f3743754e1cb9c3c253003d350ee3503f42e1ead9b0439922edc5a3149d2f85.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5f05e00b47c5da20a05ad6d065d71c58e0244dee8f7d95407889b2d570f85575.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4f3743754e1cb9c3c253003d350ee3503f42e1ead9b0439922edc5a3149d2f85.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5f05e00b47c5da20a05ad6d065d71c58e0244dee8f7d95407889b2d570f85575.jpeg",
  location: "Houston , TX, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "6pm Candle Co. is a Houston-based small batch candle and fragrance company that was founded in 2021. We are inspired to make high-quality handmade products with the finest ingredients for your home and body.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:24.023Z",
    importedBy: "entity-db-cli",
  },
};
